import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../services/API/auth/auth.service';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    if (!this.authService.userRolCheck('permiso_total')) {
      this.authService.logout();
    }
  }

}
